import pdfIcon from "./assets/pdf.svg";

const PDFIcon = ({ className }: { className?: string }) => (
  <img src={pdfIcon} className={className} alt="" />
);

export default PDFIcon;
